'use strict';

var getSelectedQuantities = function (tabpane) {
    var count = 0;
    tabpane.find('.quantity-select').each(function(){
        count += parseInt($(this).val()) || 0;
    });
    return count;
}

var showSelectedDetails = function (tabpane, dietSelectedList) {
    dietSelectedList.find('.diet-customize-selected-info').remove();
    tabpane.find('[data-selected]').data('selected', false);
    tabpane.find('.quantity-select').each(function(){
        if (parseInt($(this).val()) > 0) {
            $(this).closest('[data-selected]').data('selected', true);
            $('<div class="diet-customize-selected-info">'+ $(this).closest('.product-tile').find('.pdp-link a').text() +' ('+ $(this).val() +') </div>').insertBefore(dietSelectedList.find('.diet-customize-to-select'));
        }
    });
}

var updateSelectedPlan = function ($this, data) {
    var tabpane = $this.closest('.tab-pane');

    if (data && !data.product.available && !tabpane.hasClass('item-full-filled')) {
        $this.closest('.product-tile').find('.product-tile-qunaity-not-available').removeClass('d-none');
        setTimeout(function(){
            $this.closest('.product-tile').find('.product-tile-qunaity-not-available').addClass('d-none');
        }, 2000);
        $this.val($this.data('qty'));
    }

    var dietId = tabpane.attr('id');
    var dietSelectedList = $('.diet-customize-selected[data-key="'+ dietId.replace('-content', '') +'"]');
    var navItem = '#' + dietId.replace('-content', '-tab');
    var cutomizeButton = tabpane.find('.diet-customize-button');
    var selectedQty = getSelectedQuantities(tabpane);
    var val = parseInt($this.val());
    var menuName = $('.diet-customize .tab-pane:not(.item-full-filled)').not(tabpane).first().data('optionName');
    val = val >= 0 ? val : 0;
    if (selectedQty <= cutomizeButton.data('maxqty')) {
        $this.data('qty', val);
        cutomizeButton.find('.diet-customize-button-count').html(cutomizeButton.data('maxqty') - selectedQty);
        cutomizeButton.attr('qty', cutomizeButton.data('maxqty') - selectedQty);
        dietSelectedList.find('.diet-customize-to-select-count').html(cutomizeButton.data('maxqty') - selectedQty);
        dietSelectedList.find('.diet-customize-to-select-count').attr('count', cutomizeButton.data('maxqty') - selectedQty);
    } else {
        val = cutomizeButton.data('maxqty') - (selectedQty - val);
        $this.val(val).data('qty', val);
        if (val < 0) {
            $('.quantity-select').filter( function () {
                if (parseInt($(this).val()) < 0) return this;
            }).val(0);
        }
        $('#dietQtyModal').find('.dietQtyModal-current').html(cutomizeButton.data('maxqty'));
        $('#dietQtyModal').find('.dietQtyModal-total').html(cutomizeButton.data('maxqty'));
        $('#dietQtyModal').find('.dietQtyModal-item').html(tabpane.data('optionName'));
        $('#dietQtyModal').modal('show');
    }

    selectedQty = getSelectedQuantities(tabpane);
    if (selectedQty === cutomizeButton.data('maxqty')) {
        $(navItem).addClass('item-full-filled');
        tabpane.addClass('item-full-filled');
        dietSelectedList.find('.diet-customize-to-select').addClass('d-none');
    } else {
        $(navItem).removeClass('item-full-filled');
        tabpane.removeClass('item-full-filled');
        dietSelectedList.find('.diet-customize-to-select').removeClass('d-none');
    }

    if ($('.diet-customize .tab-pane.item-full-filled:not(#eachincludes-content)').length === $('.diet-customize .tab-content').data('total')) {
        tabpane.addClass('item-show-cart');
    } else {
        tabpane.removeClass('item-show-cart');
    }

    showSelectedDetails(tabpane, dietSelectedList);

    tabpane.find('.diet-customize-next-item').html(menuName);
}

module.exports = {
    'quantitySelect': function () {
        $('body').on('blur', '.diet-customize .quantity-select', function () {
            var $this = $(this);
            if (parseInt($(this).val()) >= 0) {
                if (parseInt($(this).val()) <= 0) {
                    updateSelectedPlan($this);
                } else {
                    $this.prop('readonly', true);
                    $.ajax({
                        url: $this.data('url') + '&quantity=' + $this.val(),
                        dataType: 'JSON',
                        type: 'GET',
                        success: function (data) {
                            $this.prop('readonly', false);
                            updateSelectedPlan($this, data);
                        }
                    });
                }
            } else {
                $(this).val($(this).data('qty'));
            }
        });
    },

    dietCustomizeEvents: function () {
        $('.diet-customize .quantity-select').val(0); // On load set product value to 0

        $('body').on('click', '.diet-customize-header-back-button', function () {
            $('.page').removeClass('diet-customize-open');
        });

        $('.diet-customize-buttons .diet-customize-next-button').each(function () {
            $(this).find('.diet-customize-next-item').html($(this).closest('.tab-pane').next().data('optionName'));
            $(this).removeClass('d-none');
        });

        $('body').on('click', '.diet-customize-buttons .diet-customize-next-button', function (e) {
            e.preventDefault();
            var tabElement = $('.diet-customize .tab-pane:not(.item-full-filled)').not($(this).closest('.tab-pane')).first().data('optionId');
            $('.diet-customize-nav #' + tabElement + '-tab').trigger('click');
        });

        $('body').on('click', '.add-to-cart-customize-button', function() {
            $(window).scrollTop(0);
            $('.page').addClass('diet-customize-open');
            if (!$('.diet-customize-header-menu').is(':visible')) {
                $('.diet-slim-scroll').slimScroll({
                    size: '5px',
                    color: '#DADADA'
                });
            }
            $("input[value='false'].dietProductOOS, input[value='null'].dietProductOOS").parents('.diet-customize-product').removeClass('d-flex').addClass('d-none');
        });

        $('body').on('click', '.diet-customize-header-hamburger', function () {
            $('.diet-customize-nav-overlay').addClass('active');
        }).on('click', '.diet-customize-nav-overlay-header', function () {
            $('.diet-customize-nav-overlay').removeClass('active');
        });

        $('.diet-customize-nav a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            $('.diet-customize-header-selection-name').html($(e.target).data('name'));
            $('.diet-customize-nav-overlay').removeClass('active');

            $($(e.target).attr('href')).find('.quantity-select').first().trigger('blur');
            if ($(e.target).attr('id') === 'diet-content-tab') {
                $($(e.target).attr('href')).find('.diet-customize-next-item').html($('.diet-customize .tab-pane:not(.item-full-filled)').not(e.target).first().data('optionName'));
                if ($('.diet-customize .tab-pane.item-full-filled:not(#eachincludes-content)').length === $('.diet-customize .tab-content').data('total')) {
                    $($(e.target).attr('href')).addClass('item-show-cart');
                } else {
                    $($(e.target).attr('href')).removeClass('item-show-cart');
                }
            }
        }).on('click', function (e) {
            if ($('.diet-customize-nav-overlay').css('position') === 'fixed') {
                $('.diet-customize-nav-overlay').removeClass('active');
            }
        });

        $('.diet-customize-header-menu').on('click', function (e) {
            $('.diet-slim-scroll').slimScroll({destroy:true});
            $('#dietMenuModal .modal-body').html($('.diet-customize .diet-selected-column').clone());
            $('#dietMenuModal').modal('show');
        });

        $(window).on('scroll', function () {
            if ($(window).width() >= 992 && $('div.diet-customize-buttons').is(':visible') && $(this).scrollTop() > 100) {
                $('div.diet-customize-buttons').addClass('sticky');
            } else {
                $('div.diet-customize-buttons').removeClass('sticky');
            }
        });
    }
};
